import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { pure, compose } from 'recompose';
import fullName from 'common/utils/fullName';
import {
    Item,
    Initials,
    InitialsErrorBadge,
    Date,
    Actions,
    Action,
    connectActiveItem,
    PdfAction,
} from 'components/list';
import Contact from 'components/rip/Contact';
import { withSession } from '../../../../components/sessions';
import { isCouple } from '../../../../../../common/src/utils/hasPartner';
import isCgpStatus from '../../../../common/utils/isCgpStatus';

const ListItem = ({
    isActive,
    contactDisplayed,
    show,
    item: rip,
    allMode,
    session,
}) => {
    const {
        id,
        firstName,
        lastName,
        updatedAt,
        mobile,
        personalEmail,
        familySituation,
        partnerFirstName,
        partnerLastName,
        partnerMobile,
        partnerPersonalEmail,
        user,
        contactOrigin,
        contactOriginOther,
        errorCount,
        signatureDate,
        validators,
    } = rip;

    return (
        <Fragment>
            <Item
                key={id}
                displayActions={isActive}
                onFocus={!isActive ? () => show() : null}
            >
                <Initials firstName={firstName} lastName={lastName}>
                    {null !== errorCount && (
                        <InitialsErrorBadge
                            errorCount={errorCount}
                            signatureDate={signatureDate}
                            isAvailable
                        />
                    )}
                </Initials>
                <td>{fullName({ firstName, lastName })}</td>
                {!isCgpStatus(session.status) ? (<td>{fullName(user)}</td>) : <td />}
                {!isCgpStatus(session.status) ? <td>{get('entity.name', user)}</td> : <td />}
                {allMode && !isCgpStatus(session.status) && (
                    <td>
                        {validators.map((validator) => validator && (
                            <div key={validator.id}>{fullName(validator)}</div>
                        ))}
                    </td>
                )}
                {!isCgpStatus(session.status) ? (<Date date={updatedAt} />) : <td />}

                <td>En attente</td>
                {!isCgpStatus(session.status) && (
                    <Actions>
                        <Action
                            to={`/rip/${id}/etat-civil`}
                            icon="pencil"
                            text="modifier"
                        />
                        <PdfAction url={`/api/rips/${id}/pdf`} />
                        <Action
                            onClick={() => show('contact')}
                            icon="comments-o"
                            text="contact"
                        />
                        <Action
                            to={`/rip/${id}/approval/none`}
                            onClick={() => show('contact')}
                            icon="share"
                            text="Validation"
                        />
                    </Actions>
                )}

            </Item>
            {contactDisplayed ? (
                <Contact
                    key={`${id}-contact`}
                    fullName={fullName({ firstName, lastName })}
                    mobile={mobile}
                    personalEmail={personalEmail}
                    isCouple={isCouple(familySituation)}
                    partnerFullName={fullName({ firstName: partnerFirstName, lastName: partnerLastName })}
                    partnerMobile={partnerMobile}
                    partnerPersonalEmail={partnerPersonalEmail}
                    contactOrigin={contactOrigin}
                    contactOriginOther={contactOriginOther}
                />
            ) : null}
        </Fragment>
    );
};
ListItem.propTypes = {
    isActive: PropTypes.bool.isRequired,
    contactDisplayed: PropTypes.bool.isRequired,
    show: PropTypes.func.isRequired,
    item: PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        createdAt: PropTypes.string.isRequired,
        updatedAt: PropTypes.string.isRequired,
        mobile: PropTypes.string,
        personalEmail: PropTypes.string,
        familySituation: PropTypes.string,
        partnerFirstName: PropTypes.string,
        partnerLastName: PropTypes.string,
        partnerMobile: PropTypes.string,
        partnerPersonalEmail: PropTypes.string,
        user: PropTypes.string,
        contactOrigin: PropTypes.string,
        contactOriginOther: PropTypes.string,
        errorCount: PropTypes.number,
        signatureDate: PropTypes.string,
        validators: PropTypes.string,
    }).isRequired,
    allMode: PropTypes.bool,
    session: PropTypes.shape({
        status: PropTypes.string,
    }).isRequired,
};

ListItem.defaultProps = {
    allMode: false,
};

export default compose(
    withSession,
    pure,
    connectActiveItem(({ item: { id } }) => id, (item, { activeItem, target }) => {
        const isActive = item === activeItem;

        return {
            isActive,
            contactDisplayed: isActive && 'contact' === target,
        };
    }),
)(ListItem);
